import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleMapStyleComponent } from './toggle-map-style.component';

@NgModule({
    declarations: [
        ToggleMapStyleComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ToggleMapStyleComponent
    ]
})
export class ToggleMapStyleModule { }
